var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',{attrs:{"attributes":_vm.attrs,"min-date":_vm.minDate,"disabled-dates":{ weekdays: [1, 7] },"mode":"single","is-inline":true},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }